import { app } from '../../app.module'
/**
 * SNSを複数選択するフォーム
 * attribute: {array} selected-val 選択されたSNS種別
 */
class SnsMultiFormComponentCtrl {
  private scope: ng.IScope
  private selectedVal: {}

  constructor($scope) {
    this.scope = $scope
  }

  /**
   * 選択されたイベントともに、イベントを送信する
   */
  public selectSns() {
    this.scope.$emit('setSNSAccessControl', this.selectedVal)
  }
}

app.component('snsMultiForm', {
  bindings: {
    selectedVal: '<',
  },
  template: require('./sns-multi-form.pug')(),
  controller: SnsMultiFormComponentCtrl,
})
